// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"1155045b","239":"5e259d15","455":"b021ed3e","865":"bad60d06","977":"a9af0f5b"}[chunkId] + ".chunk.js";
};